import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService           from 'FactoryService.js';
import constants                from 'Constants.js';
import sequenceService          from 'SequenceService.js';
import ControlModel    from 'ControlModel.js';
import CrosstabView      from 'report/CrosstabView.js';
import listService from 'ListService';


class ControlCrosstabFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;
        const defaultFont = listService.accountSettings.DefaultFontSelected || "verdana";
        //adding silent(accessibility) to attributes.
		attributes.silent = false;

        // Rows
		attributes.styleColorText ='#000000';
        attributes.fontFamily =  defaultFont;
        attributes.fontSize = '10';
        attributes.textWeight = '';
        attributes.textStyle  = '';

        attributes.headerTextColor ='#000000';
		attributes.headerFontFamily = defaultFont;
		attributes.headerFontSize = '10';
		attributes.headerTextWeight = '';
		attributes.headerTextStyle  = '';

		attributes.backgroundColor = '#FFFFFF';
		attributes.advancedBgGradientColor = '~buttonBgGradientColor';

        attributes.headerBgColor = '#FFFFFF';
        attributes.normalRowBgColor = '~tableRowColor1';
        attributes.alternateRowBgColor = '~tableRowColor2';

        attributes.headerBoldSelection = 'transparent';
        attributes.headerItalicSelection = 'transparent';

        attributes.setFilter = 'checked';
        attributes.overridePrevious = '';
        attributes.respectDynamicFilter = 'checked';
        attributes.showAllValues = '';
        attributes.newWindow = 'checked';
        attributes.description = '';

        attributes.groupTop = 'None';
        attributes.groupSide = 'None';
        attributes.valueMath = 'Count';
        attributes.valueType = 'None';
        attributes.resizePadding = 2;
		attributes.minWidth = 10;
		attributes.minHeight = 150;
        attributes.lowestHeight = 150;
        attributes.respectDynamicFilter = 'true';
        attributes.additiveDynamicFilter = 'true';
        attributes.setDynamicFilter = 'true';
        attributes.ignoreNull = 'true';
        attributes.dataSourceId = 'null';
        
        attributes.Columns = { Column: [{id:'0', Properties: {
            fieldId: '',
            align: 'left',
            visible: 'true',
            formatoption: '',
            caption: '',
            setDynamicFilter: 'false',
            width: '150',
            format: 'none',
            usesExpression: 'false',    
            sortOrder: '0',        
            sortType: 'none',
            aggregation: 'group',
            fieldDataType: ''
           }},
           {id:'1', Properties: {
            fieldId: '',
            align: 'left',
            visible: 'true',
            formatoption: "",
            caption: '',
            setDynamicFilter: 'false',
            width: '150',
            format: 'none',
            usesExpression: 'false',    
            sortOrder: '0',        
            sortType: 'none',
            aggregation: 'group',
            fieldDataType: ''
           }},
           {id:'2', Properties: {
            fieldId: '',
            align: 'left',
            visible: 'true',
            formatoption: "",
            caption: '',
            setDynamicFilter: 'false',
            width: '150',
            format: 'none',
            usesExpression: 'false',    
            sortOrder: '0',        
            sortType: 'none',
            aggregation: 'count',
            fieldDataType: ''
           }}  
        ]};

        const view = new CrosstabView( { 
            model: new ControlModel( attributes ),
            el: $(constants.FORM_ID),
            pos: pos, 
            factoryKey: factoryKey, 
            id: attributes.id
        });

        return view;
    }

}

const controlCrosstabFactory = new ControlCrosstabFactory();

export default controlCrosstabFactory;